if (!customElements.get('atc-form')) {
  class AtcForm extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('submit', (event) => this.#onSubmit(event));
    }

    #cartDrawer;

    async #onSubmit(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      if (!form) return;

      const formData = new FormData(form);

      formData.append(
        'sections',
        this.#cartDrawer
          .getSectionsToRender()
          .map((section) => section.section),
      );
      formData.append('sections_url', window.location.pathname);

      const response = await addToCart(formData);
      this.#cartDrawer?.renderContents(response);
    }

    connectedCallback() {
      this.#cartDrawer = document.querySelector('cart-drawer');
    }
  }
  customElements.define('atc-form', AtcForm);
}
